import './Arrow.css';

const ArrowNavigation = ({ goToPreviousPage, goToNextPage, currentPage, pages }) => {
  return (
    <div className="arrow-navigation">
      <div>
        {/* <div>{pages[(currentPage - 1 + pages.length) % pages.length].header}</div> */}
        <button className="arrow-button" onClick={goToPreviousPage}>
          {/* <img src="/icons/chevron-left.svg" alt="Back" /> */}
          <svg
            className="chevron-icon"
            fill="none"
            viewBox="0 0 16 16"
            stroke="currentColor"
          >
            <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
          </svg>
        </button>
      </div>

      <div>
        {/* <div>{pages[(currentPage + 1) % pages.length].header}</div> */}
        <button className="arrow-button" onClick={goToNextPage}>
          {/* <img src="/icons/chevron-right.svg" alt="Back" /> */}
          <svg
            className="chevron-icon"
            fill="none"
            viewBox="0 0 16 16"
            stroke="currentColor"
          >
            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ArrowNavigation;
